import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISTableComponent } from './is-table.component';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CdkMenuModule } from '@angular/cdk/menu';
import { ISSelectModule } from '../is-select/is-select.module';
import { ISDialogModule } from '../is-dialog/is-dialog.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { ISDateTimePickerModule } from '../is-date-time-picker/is-date-time-picker.module';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from '../shared.module';
import { ISMultiSelectModule } from "../is-multi-select/is-multi-select.module";
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaginationService } from './is-table';
import { MatChipsModule } from '@angular/material/chips';

const materialModules = [
    MatIconModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatInputModule,
    CdkMenuModule,
    MatMenuModule,
    RouterModule,
    OverlayModule,
    DragDropModule,
    MatTooltipModule,
    MatChipsModule
];

const isModules = [
    ISSelectModule,
    ISDateTimePickerModule,
    ISDialogModule,
    ISMultiSelectModule
];

@NgModule({
    declarations: [ISTableComponent],
    imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    ...materialModules,
    ...isModules
],
    exports: [ISTableComponent],
    providers: [{ 
        provide: MatPaginatorIntl,
        useClass: PaginationService
    }],
})
export class ISTableModule { }